import { render, staticRenderFns } from "./notification-schedule-day.vue?vue&type=template&id=4ad6225a"
import script from "./notification-schedule-day.vue?vue&type=script&lang=js"
export * from "./notification-schedule-day.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports